import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { Icon } from "@/components/site/Icon";
import { SectionHeading } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";
import { buyService } from "@/lib/cart";
import { inr, track } from "@/lib/api";

export function ServicesGrid({ heading = true }) {
    const nav = useNavigate();
    const { data: services } = useFetch("/services", []);
    const go = (slug) => { buyService(slug); track("cta_click", { cta: "service_get_started", slug }); nav("/checkout"); };

    return (
        <section id="services" className="bg-teal-900 py-20" data-testid="services-section">
            <div className="container-x">
                {heading && (
                    <div className="mb-12 text-center flex flex-col items-center">
                        <SectionHeading center eyebrow="Services" title="One Platform. Every Digital Growth Service."
                            subtitle="Choose exactly what your business needs — or let our team build the right combination for you." />
                    </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {(services || []).map((s, i) => (
                        <motion.div key={s.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }}
                            className="card-teal rounded-2xl p-6 flex flex-col" data-testid={`service-card-${s.slug}`}>
                            <div className="flex items-center justify-between">
                                <div className="w-12 h-12 rounded-xl bg-gold/15 border border-gold/30 flex items-center justify-center">
                                    <Icon name={s.icon} className="w-6 h-6 text-gold" />
                                </div>
                                <div className="text-right">
                                    <div className="text-[11px] text-cream-soft/70 uppercase tracking-wide">Starting from</div>
                                    <div className="font-mono font-bold text-2xl text-cream">{inr(s.starting_price)}</div>
                                </div>
                            </div>
                            <h3 className="mt-5 text-xl font-bold text-cream">{s.name}</h3>
                            <p className="mt-2 text-sm text-cream-soft flex-1">{s.description}</p>
                            <ul className="mt-4 space-y-2">
                                {s.features.slice(0, 5).map((f) => (
                                    <li key={f} className="flex items-start gap-2 text-sm text-cream-soft"><Check className="w-4 h-4 text-growth mt-0.5 shrink-0" /> {f}</li>
                                ))}
                            </ul>
                            <div className="mt-6 flex gap-2">
                                <button onClick={() => go(s.slug)} className="btn-gold rounded-full px-4 py-2.5 text-sm flex-1 flex items-center justify-center gap-1.5" data-testid={`service-buy-${s.slug}`}>
                                    {s.cta || "Get Started"}
                                </button>
                                <button onClick={() => nav(`/services/${s.slug}`)} className="btn-ghost-cream rounded-full px-4 py-2.5 text-sm flex items-center justify-center" data-testid={`service-learn-${s.slug}`}>
                                    <ArrowRight className="w-4 h-4" />
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
